const readmore = {
    init: function () {

        this.readmores = [...document.querySelectorAll("[readmore]:not([readmore=init])")];

        this.readmores.map(r => {
            let openButton = r.querySelector("[readmore-open-button]");
            let closeButton = r.querySelector("[readmore-close-button]");

            //closeReadmore(r);
            if (openButton) {
                openButton.addEventListener("click", () => this.openReadmore(r));
            }
            //if (closeButton) {
            //    closeButton.addEventListener("click", () => closeReadmore(r));
            //}
            r.setAttribute("readmore", "init");
        });

    },

    closeReadmore: function (readmore) {
        if (!readmore) return;
        closeContent(readmore.querySelector("[readmore-content]"));
        setClosedClass(readmore.querySelector("[readmore-open-button]"));
        setClosedClass(readmore.querySelector("[readmore-close-button]"));
    },

    openReadmore: function (readmore) {
        if (!readmore) return;
        readmore.setAttribute("readmore-activated", "")
        this.openContent(readmore.querySelector("[readmore-content]"));
        this.setOpenClass(readmore.querySelector("[readmore-open-button]"));
        this.setOpenClass(readmore.querySelector("[readmore-close-button]"));
    },

    openContent: function (content) {
        if (!content) return;
        this.setOpenClass(content);
    },

    closeContent: function (content) {
        if (!content) return;
        setClosedClass(content);
        content.style.height = null;
    },

    setClosedClass: function (element) {
        if (!element) return;

        setClasses(element, element.getAttribute("readmore-open-class"), "remove");
        setClasses(element, element.getAttribute("readmore-closed-class"), "add");
    },

    setOpenClass: function (element) {
        if (!element) return;

        //this.setClasses(element, element.getAttribute("readmore-closed-class"), "remove");
        this.setClasses(element, element.getAttribute("readmore-open-class"), "add");
    },

    setClasses: function (element, classList, func) {
        if (!element || !classList) return;
        let classes = classList.split(" ");
        if (func === "remove") {
            classes.map(c => element.classList.remove(c));
        }
        else {
            classes.map(c => element.classList.add(c));
        }
    }
};

export default readmore.init();
